import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { ForeclosureSummaryStore } from '../stores/foreclosureSummaryStore';

export const useForeclosureSummaryStore = () =>
  useContext<{
    foreclosureSummaryStore: ForeclosureSummaryStore;
  }>(StoreContext);